<template lang="pug">
.conteudo(:class='isLoading ? "--loading" : ""')
    .linha.--nova
        .coluna--nova
            img(v-if="isTokenSolicitado" :src="getIconeCaminho", alt='')
            .linha
            title-component(:label='getTitulo', style="font-size: 35px;")
            title-component(:label='getSubTitulo', style="font-size: 35px;")
    .linha.--nova
        .container
            .coluna
                button(
                    v-if='!isTokenSolicitado',
                    class="button-custom--",
                    @click='solicitarToken($event)'
                )
                    .button-label Solicitar

            .coluna-1

            .coluna
                button(
                    class="button-custom--",
                    :style='!this.isTokenSolicitado ? "--button-background-color: red;" : "button-background-color: green"'
                    @click="sairAnalisePrada($event)"
                )
                    .button-label  {{this.isTokenSolicitado ? "Ok" :  "Sair"}}

</template>

<script>

import { solicitarToken } from '@/services/authenticate.service';
import gifSuccess from '@/assets/success.svg';

export default {

    name: 'SolicitacaoToken',

    data() {
        return {
            loading: false,
            titulo: "",
            subTitulo: "",
            tokenSolicitado: false
        }
    },

    mounted() {
        this.updateTitulo("Olá " + this.getPrimeiroNome + ", parece que sua chave de acesso expirou.", "Deseja solicitar uma nova chave de acesso?")
    },

    computed: {
        getTitulo()  {
            return this.titulo;
        },

        getSubTitulo()  {
            return this.subTitulo;
        },

        getIconeCaminho() {
            return gifSuccess
        },

        isLoading()  {
            return this.loading;
        },

        getPrimeiroNome() {
            return this.$dadosAssinanteExterno() ? this.$dadosAssinanteExterno().nome.slice(0, this.$dadosAssinanteExterno().nome.indexOf(' ')) : "Assinante";
        },

        isTokenSolicitado() {
            return this.tokenSolicitado
        }
    },

    methods: {
        async solicitarToken() {
            try {
                this.loading = true
                const response = await solicitarToken()

                if (response.status == 200) {
                    this.tokenSolicitado = true;
                    this.updateTitulo("Chave de acesso solicitada com sucesso!", "Em alguns instantes você receberá e-mail com uma nova chave de acesso.")
                }
                this.loading = false
            } catch (error) {
                this.loading = false
                this.apresentaToast(error, 'error')
            }
        },

        updateTitulo(titulo, subtitulo){
            this.titulo = titulo;
            this.subTitulo = subtitulo;
        },

        apresentaToast(message, type) {
            if(!message)
                return

            this.$toast({
                showClose: true,
                message: message,
                type: type
            });
        },

        sairAnalisePrada() {
            window.location.href = process.env.VUE_APP_SICAR_URL;
        }
    },
}
</script>

<style lang="scss">
.linha.--nova{
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 20px;
}

.coluna--nova{
    display: flex;
    max-width: 100% !important;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.container {
    display: flex;
}

.--loading {
    position: relative;
}

.--loading:after {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: var(--primary-smoke);
    background-image: url('../../assets/loading.gif');
    background-position: center;
    background-repeat: no-repeat;
    background-size: 50px 50px;
}

.button-custom-- {
    display: flex !important;
    flex-direction: row;
    align-items: center;
    text-align: center;
    justify-content: center;
    border: none;
    text-decoration: none;
    padding: 10px 5px 10px 5px;
    border-radius: 5px;
    height: 50px;
    width: 120px;
    font-size: 20px;
    display: inline-block;
    cursor: pointer;
    color: var(--primary-white);
    background-color: var(--button-background-color, var(--primary-green));
    border: 1px solid transparent;
}

</style>
